module.exports = __webpack_public_path__ + "img/11.26215d5a.png";